import { RegistrationStatusType } from "@/lib/gql/__generated__/graphql";

import type * as FormModelType from "@/components/features/invoice-system-settings/model/type";

export const invoiceSystemSettingsInputModelFactory = (
	id: string,
	hotelID: string,
): FormModelType.InvoiceSystemSettingsFormModel["InputModel"] =>
	({
		id,
		hotelID,
		registrationStatus: RegistrationStatusType.NotRegistered,
		registrationCode: undefined,
	}) satisfies FormModelType.InvoiceSystemSettingsFormModel["InputModel"];
